import template from './bar-list.html';

export default angular
  .module('app.holding.dashboard.bars')
  .directive('holdingBarList', holdingBarList)
  .name;

function holdingBarList() {
  'ngInject';

  return {
    link,
    require: '?ngModel',
    restrict: 'E',
    scope: {
      bars: '=',
      metal: '=',
      productCode: '=',
      select: '=',
      sortable: '=?',
      sorting: '=?',
    },
    template,
  };

  function link(scope, _element, attrs, model) {
    scope.showVault = Object.prototype.hasOwnProperty.call(attrs, 'vault');
    scope.showRegistrationId = Object.prototype.hasOwnProperty.call(attrs, 'registrationId');
    scope.showRegistrationDate = Object.prototype.hasOwnProperty.call(attrs, 'registrationDate');
    scope.model = model;
    scope.viewModel = {};

    scope.$watch('sorting', (value) => {
      scope.viewModel.sorting = value;
    });
    scope.$watch('viewModel.sorting', (value) => {
      scope.sorting = value;
    });

    scope.selectBar = (bar) => {
      if (scope.select && model) {
        model.$setViewValue(bar);
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/bars/directives/bar-list/bar-list.js